import { apiClient, fastApiClient } from "../App";

// Get Voices
export const getVoices = () => {
  return apiClient.get("/voices");
};

// Clone Voice
export const cloneVoice = (formData) => {
  return apiClient.post("/voices/clone", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Preview Voice
export const previewVoice = (data) => {
  return apiClient.post("/voices/tts", data);
};

// Generate AI Template
export const generateTemplate = (data) => {
  return fastApiClient.post("/ai/generate-template", data);
};